import type {CSSProperties} from 'react';
import {TOUCH_MIN} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

/* NotifPrefs keeps the native time picker and caller-owned validation. */
export const wedgeTimeFieldStyle: CSSProperties = {
  padding:'8px 10px', background:wedgeExactRole('bgElev'),
  border:`1px solid ${wedgeExactRole('cardBorder')}`, borderRadius:10,
  fontSize:13.5, color:wedgeExactRole('label'), fontFamily:wedgeExactRole('font'),
  outline:0, width:110, boxSizing:'border-box',
};

/* The transparent strips extend only outside the native input. */
export const WEDGE_TIME_FIELD_CSS = `[data-rv-wedge-time-hit]::before,
[data-rv-wedge-time-hit]::after {
  content: ""; position: absolute; left: 0; width: 100%;
  height: max(0px, calc((${TOUCH_MIN}px - 100%) / 2));
  background: transparent;
}
[data-rv-wedge-time-hit]::before { bottom: 100%; }
[data-rv-wedge-time-hit]::after { top: 100%; }`;
export const wedgeTimeHitStyle: CSSProperties = {
  position: 'relative', display: 'inline-flex', font: 'inherit', color: 'inherit',
  padding: 0, border: 0, margin: 0,
};
